import React from 'react';
import BomModelList from '../../../components/admin/bomModel/BomModelList';

const BomModels: React.FC = () => {

    return (<div>
        <BomModelList />
    </div>)
};

export default BomModels;